import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import Cyborg from '../components/Cyborg/Cyborg'
import InvestmentsWrapper from '../components/Investments/InvestmentsWrapper'
import Partners from '../components/Partners/Partners'
import AboutWrapper from '../components/SAIRUS_NEW/About/AboutWrapper'
import FaqWrapper from '../components/SAIRUS_NEW/Faq/FaqWrapper'
import FooterWrapper from '../components/SAIRUS_NEW/Footer/FooterWrapper'
import NewsWrapper from '../components/SAIRUS_NEW/News/NewsWrapper'
import OpportunitiesWrapper from '../components/SAIRUS_NEW/Opportunities/OpportunitiesWrapper'
import Promo from '../components/SAIRUS_NEW/Promo/Promo'
import RoadmapWrapper from '../components/SAIRUS_NEW/Roadmap/RoadmapWrapper'
import SocialWrapper from '../components/SAIRUS_NEW/Social/SocialWrapper'
import TechnologiesWrapper from '../components/SAIRUS_NEW/Technologies/TechnologiesWrapper'
import WhatCanWrapper from '../components/SAIRUS_NEW/WhatCan/WhatCanWrapper'
import useMediaQuery from '../hooks/useMediaQuery'

const LandingPage = () => {
	const searchParams = useSearchParams()
	const matches = useMediaQuery('(min-width: 750px)')

	useEffect(() => {
		if (searchParams[0].get('ref')) {
			localStorage.setItem('ref', searchParams[0].get('ref') || '')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<Promo />
			<AboutWrapper />
			<TechnologiesWrapper />
			<OpportunitiesWrapper />
			<WhatCanWrapper />
			<SocialWrapper />
			<RoadmapWrapper />
			<InvestmentsWrapper />
			<NewsWrapper />
			<FaqWrapper />
			<Partners />
			<FooterWrapper />
			{/* <About /> */}
			{/* <Technologies /> */}
			{/* <Opportunities /> */}
			{/* <WhatCan /> */}
			{/* <Social /> */}
			{/* <Roadmap /> */}
			{/* <Investments /> */}
			{/* <News /> */}
			{/* <Faq /> */}
			{/* <Footer /> */}
			{matches && <Cyborg />}
		</>
	)
}

export default LandingPage
